import moment from 'moment';

import { Form, HoursInput, TimePickerInput } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { IWorkingTime } from 'src/pages/employee/employee.interfaces';
import { WORKING_DAYS } from 'src/pages/employee/sub-pages/employee-details/employee-details.constants';

const WorkingDay = ({
  days,
  condition,
}: {
  days: { [key: string]: IWorkingTime };
  condition?: boolean;
}) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <div>
      {WORKING_DAYS.map((day, index) => (
        <div key={day}>
          {(condition ? index < 4 : index >= 4) && (
            <Form.Item
              name={['workingDays', day]}
              label={t(`days.${day}`)}
              initialValue={days[day] ? [moment(days[day].from), moment(days[day].to)] : null}
            >
              <TimePickerInput.RangePicker showSecond={false} format="HH:mm" />
            </Form.Item>
          )}
        </div>
      ))}
      {!condition && (
        <Form.Item
          name="breakTime"
          label={t('employee:labels.breakTime')}
          rules={[{ required: true, message: t('employee:validationError.breakTimeRequired') }]}
        >
          <HoursInput />
        </Form.Item>
      )}
    </div>
  );
};

export default WorkingDay;
